import _ from 'lodash'

import { vsName as ServerUtilityName } from '../../../../records/server/serverUtility'

import fieldHelpers from '../../../../ui-formly/fieldHelpers'

partPropertyEditFields.$inject = []
function partPropertyEditFields() {
  const fields = [
    ...fieldHelpers.columnLayout([
      {
        key: 'Name',
        type: 'input',
        templateOptions: {
          label: 'Name',
          required: true
        }
      },
      {
        key: 'PropertyId',
        type: 'selectAsync',
        templateOptions: {
          label: 'Property',
          required: true,
          showAddButton: false,
          query: [ServerUtilityName, function (serverUtility) {
            return function(search){
              return serverUtility.lookupQuery({
                url: "/api/properties",
                search
              })
            }            
          }],
          getDefaultItem: function (model) {
            const property = _.get(model, 'Property', {})
            return {
              Id: property.Id,
              Name: property.Name
            }
          },
          updateNameProp: '.PropertyName'
        }
      }
    ], 4)
  ]

  return fields
}

export default partPropertyEditFields